import React from "react";
import { Button, Box } from "@mui/material";

export default function QuestionGeneratorButton({ chapterText, onGenerate }) {
  const handleClick = () => {
    // Example: generate questions (replace with actual logic)
    const sampleQuestions = [
      { question: "What is the main idea?", type: "ShortAnswer" },
      { question: "Pick the correct answer", type: "MCQ", options: ["A", "B", "C"] },
    ];
    onGenerate(sampleQuestions);
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "flex-start", mt: 2 }}>
      <Button
        variant="contained"
        color="secondary"
        onClick={handleClick}
      >
        Generate Questions
      </Button>
    </Box>
  );
}
